"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-areas: 'select';\n  align-items: center;\n  position: relative;\n  min-width: 150px;\n  border-radius: ", ";\n  background: ", ";\n  padding: ", " 15px;\n  transition: box-shadow 0.25s linear, opacity 0.25s linear;\n  box-shadow: 0 0 ", " transparent;\n\n  select {\n    appearance: none;\n    background-color: transparent;\n    border: none;\n    padding: 0 1em 0 0;\n    margin: 0;\n    width: 100%;\n    font-family: inherit;\n    font-size: ", ";\n    cursor: inherit;\n    line-height: inherit;\n    z-index: 1;\n    outline: none;\n  }\n\n  .arrow {\n    justify-self: end;\n    font-size: 14px;\n    width: 14px;\n    height: 14px;\n    span {\n      display: block;\n      color: rgba(0, 0, 0, 0.25);\n    }\n    /* path {\n      fill: rgba(0, 0, 0, 0.25);\n    } */\n  }\n\n  select,\n  .arrow {\n    grid-area: select;\n  }\n\n  &:focus-within {\n    box-shadow: 0 0 ", "\n      ", ";\n  }\n\n  &.disabled {\n    cursor: not-allowed;\n    opacity: 0.75;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleSelect = void 0;

var icons_1 = require("@ant-design/icons");

var polished_1 = require("polished");

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("./styledTypes");

var NONE_VALUE = '--none--';

function SimpleSelect(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      options = _ref.options,
      disabled = _ref.disabled,
      style = _ref.style,
      allowClear = _ref.allowClear;
  return react_1.default.createElement(SimpleSelectContainer, {
    className: disabled ? 'disabled' : undefined,
    style: style
  }, react_1.default.createElement("select", {
    value: value || NONE_VALUE,
    disabled: disabled,
    onChange: function onChange(e) {
      if (_onChange) {
        _onChange(e.target.value);
      }
    }
  }, allowClear || !value ? react_1.default.createElement("option", {
    value: NONE_VALUE
  }, "-- None --") : undefined, options.map(function (opt) {
    var label = typeof opt === 'string' ? opt : opt.label || opt.value;
    var value = typeof opt === 'string' ? opt : opt.value;
    return react_1.default.createElement("option", {
      key: value,
      value: value
    }, label);
  })), react_1.default.createElement("div", {
    className: 'arrow'
  }, react_1.default.createElement(icons_1.DownOutlined, null)));
}

exports.SimpleSelect = SimpleSelect;
var SimpleSelectContainer = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.theme['@border-radius-base'];
}, function (props) {
  return props.theme['@gray-1'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@size-xxs'];
}, function (props) {
  return props.theme['@font-size-base'];
}, function (props) {
  return props.theme['@size-xxs'];
}, function (props) {
  return (0, polished_1.transparentize)(0.5, props.theme['@primary-color']);
});